import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/Themecontext";
import Api from "../api/Api";

export default function UserFormacaoPage() {
  const { dark } = useTheme();
  const navigate = useNavigate();

  const [formacoes, setFormacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [search, setSearch] = useState("");
const [vozes, setVozes] = useState([]);
const [vozSelecionada, setVozSelecionada] = useState(null);
const [isSpeaking, setIsSpeaking] = useState(false);
const [isPaused, setIsPaused] = useState(false);
const [audioModalOpen, setAudioModalOpen] = useState(false);
const [progress, setProgress] = useState(0); // 0 a 100
const [textoAtual, setTextoAtual] = useState("");

  // Visualização de formação
  const [viewingFormacao, setViewingFormacao] = useState(null);

  // Notas
  const [notasPanel, setNotasPanel] = useState(false);
  const [notaTexto, setNotaTexto] = useState("");
  const [notaLoading, setNotaLoading] = useState(false);
  const [notaSalvando, setNotaSalvando] = useState(false);
  const [notaFeedback, setNotaFeedback] = useState(null);
  const [code, setCode] = useState(null);

  // ID do utilizador logado
  const storedUser = localStorage.getItem("user");
  const currentUser = storedUser ? JSON.parse(storedUser) : null;
  const userId = currentUser?.id;

  useEffect(() => {
  const carregarVozes = () => {
    const todasVozes = speechSynthesis.getVoices();
    const vozesPt = todasVozes.filter((v) => v.lang.startsWith("pt"));
    setVozes(vozesPt.length > 0 ? vozesPt : todasVozes);
    // seleciona a primeira por defeito, só se ainda não houver escolha
    setVozSelecionada((atual) => atual || (vozesPt[0] || todasVozes[0] || null));
  };

  carregarVozes();
  speechSynthesis.addEventListener("voiceschanged", carregarVozes);
  return () => speechSynthesis.removeEventListener("voiceschanged", carregarVozes);
}, []);

  // ══════════ Tokens de cor ══════════
  const t = dark
    ? {
        bg: "#080c14",
        bgCard: "#111827",
        bgHover: "rgba(0,144,231,0.08)",
        bgActive: "rgba(0,144,231,0.16)",
        bgInput: "#1a2232",
        bgDropdown: "#111827",
        border: "rgba(0,174,255,0.12)",
        borderActive: "rgba(0,174,255,0.35)",
        textPrimary: "#eef5ff",
        textSecondary: "#b0c7e0",
        textMuted: "#7b93b0",
        textActive: "#00b4ff",
        shadow: "0 12px 40px rgba(0,0,0,0.8)",
        rowHover: "rgba(0,144,231,0.06)",
        success: "#22c55e",
        successBg: "rgba(34,197,94,0.12)",
        danger: "#ef4444",
        dangerBg: "rgba(239,68,68,0.12)",
        overlay: "rgba(8,12,20,0.85)",
      }
    : {
        bg: "#f4f7fc",
        bgCard: "#ffffff",
        bgHover: "#f0f6ff",
        bgActive: "#e6f0ff",
        bgInput: "#fafbfd",
        bgDropdown: "#ffffff",
        border: "#e2e8f0",
        borderActive: "rgba(0,100,230,0.4)",
        textPrimary: "#0f1a2e",
        textSecondary: "#475569",
        textMuted: "#8b9eb0",
        textActive: "#0057ff",
        shadow: "0 8px 30px rgba(0,50,150,0.06)",
        rowHover: "#f8faff",
        success: "#16a34a",
        successBg: "#f0fdf4",
        danger: "#ef4444",
        dangerBg: "#fef2f2",
        overlay: "rgba(15,23,42,0.4)",
      };

  // ── Carregar formações do utilizador ──────────────────
  const loadFormacoes = useCallback(async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      const storedUser = localStorage.getItem("user");
      const user = storedUser ? JSON.parse(storedUser) : null;
      const res = await Api.getUserFormacaoConteudo({ id: user.id });
      const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      setFormacoes(list);

      setCode(res[0]['code']);
       
     
    } catch {
      setErrorMsg("Não foi possível carregar as formações.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadFormacoes();
  }, [loadFormacoes]);

  // ── Filtro por pesquisa ───────────────────────────────
  const filtered = search
    ? formacoes.filter((f) =>
        (f.titulo || "").toLowerCase().includes(search.toLowerCase())
      )
    : formacoes;

  // ── Abrir visualização ────────────────────────────────
  const openView = (formacao) => {
    setViewingFormacao(formacao);
    setNotasPanel(false);
    setNotaTexto("");
    setNotaFeedback(null);
  };

  const closeView = () => {
    setViewingFormacao(null);
    setNotasPanel(false);
  };

  // ── Carregar nota ────────────────────────────────────
  const loadNota = async () => {
    if (!viewingFormacao || !userId) return;
    setNotaLoading(true);
    try {
      const storedUser = localStorage.getItem("user");
      const user = storedUser ? JSON.parse(storedUser) : null;
      const res = await Api.getNota({
        id: viewingFormacao.id,
        id_user: user.id,
      });
      const notas = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
      const nota = notas.length > 0 ? notas[0] : null;
      setNotaTexto(nota?.texto || "");
    } catch {
      setNotaTexto("");
    } finally {
      setNotaLoading(false);
    }
  };

  // ── Abrir/fechar painel de notas ──────────────────────
  const toggleNotas = () => {
    if (!notasPanel) {
      loadNota();
      setNotasPanel(true);
    } else {
      setNotasPanel(false);
    }
  };

  // ── Salvar nota ──────────────────────────────────────
  const handleSaveNota = async () => {
    if (!viewingFormacao || !userId) return;
    setNotaSalvando(true);
    try {
      const storedUser = localStorage.getItem("user");
      const user = storedUser ? JSON.parse(storedUser) : null;
      await Api.addNota({
        id: viewingFormacao.id,
        id_user: user.id,
        texto: notaTexto,
      });
      setNotaFeedback({ type: "success", msg: "Nota guardada!" });
      setTimeout(() => setNotaFeedback(null), 2500);
    } catch {
      setNotaFeedback({ type: "error", msg: "Erro ao guardar." });
      setTimeout(() => setNotaFeedback(null), 3000);
    } finally {
      setNotaSalvando(false);
    }
  };


const handleOpenAudioModal = () => {
  if (!viewingFormacao) return;
  setProgress(0);
  setAudioModalOpen(true);
};

const handleCloseAudioModal = () => {
  pararFala();
  setAudioModalOpen(false);
};


const falar = (texto) => {
  speechSynthesis.cancel();
  setProgress(0);
  setTextoAtual(texto);

  const utterance = new SpeechSynthesisUtterance(texto);
  if (vozSelecionada) {
    utterance.voice = vozSelecionada;
    utterance.lang = vozSelecionada.lang;
  } else {
    utterance.lang = "pt-PT";
  }

  utterance.onstart = () => { setIsSpeaking(true); setIsPaused(false); };
  utterance.onend = () => { setIsSpeaking(false); setIsPaused(false); setProgress(100); };
  utterance.onerror = () => { setIsSpeaking(false); setIsPaused(false); };
  utterance.onboundary = (event) => {
    if (event.charIndex != null && texto.length > 0) {
      setProgress(Math.min(100, (event.charIndex / texto.length) * 100));
    }
  };

  speechSynthesis.speak(utterance);
};

const pausarFala = () => {
  speechSynthesis.pause();
  setIsPaused(true);
};

const retomarFala = () => {
  speechSynthesis.resume();
  setIsPaused(false);
};

const pararFala = () => {
  speechSynthesis.cancel();
  setIsSpeaking(false);
  setIsPaused(false);
  setProgress(0);
};

 

  // ── Função para extrair texto limpo ──────────────────
  const stripHtml = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // ── Handle para ouvir a formação (texto limpo) ────────
  const handlePlayAudio = () => {
    if (!viewingFormacao) return;
    const cleanText = stripHtml(viewingFormacao.texto);
 
    falar(cleanText);
  };

  // ═══════════════ Estilos ═══════════════
  const styles = `
    .ufp-page { font-family: 'Inter', system-ui, sans-serif; background: ${t.bg}; min-height: 100vh; padding: 32px 20px; }
    .ufp-container { max-width: 1000px; margin: 0 auto; }
    .ufp-header { margin-bottom: 32px; }
    .ufp-heading { font-size: 1.65rem; font-weight: 700; letter-spacing: -0.03em; color: ${t.textPrimary}; }
    .ufp-sub { font-size: 0.88rem; color: ${t.textMuted}; margin-top: 4px; }
    .ufp-search { margin-bottom: 24px; }
    .ufp-search-box { display: flex; align-items: center; gap: 8px; background: ${t.bgCard}; border: 1px solid ${t.border}; border-radius: 14px; padding: 0 16px; height: 44px; width: 100%; max-width: 400px; transition: border 0.2s; }
    .ufp-search-box:focus-within { border-color: #0090e7; box-shadow: 0 0 0 3px rgba(0,144,231,0.15); }
    .ufp-search-box input { background: none; border: none; outline: none; font-size: 0.86rem; color: ${t.textPrimary}; width: 100%; }
    .ufp-search-box input::placeholder { color: ${t.textMuted}; }

    .ufp-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 20px; margin-top: 12px; }
    .ufp-card { background: ${t.bgCard}; border: 1px solid ${t.border}; border-radius: 18px; padding: 22px; display: flex; flex-direction: column; gap: 16px; transition: box-shadow 0.2s, border-color 0.2s; }
    .ufp-card:hover { box-shadow: ${t.shadow}; border-color: ${t.borderActive}; }
    .ufp-card-title { font-size: 1.05rem; font-weight: 700; color: ${t.textPrimary}; line-height: 1.3; }
    .ufp-card-text { font-size: 0.82rem; color: ${t.textSecondary}; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .ufp-card-actions { display: flex; gap: 10px; }
    .ufp-btn { height: 42px; padding: 0 20px; border-radius: 12px; font-weight: 600; font-size: 0.84rem; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; border: none; transition: all 0.2s; }
    .ufp-btn-primary { background: linear-gradient(135deg, #00aaff, #0044ee); color: #fff; box-shadow: 0 4px 14px rgba(0,100,255,0.3); }
    .ufp-btn-primary:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(0,100,255,0.45); }
    .ufp-btn-secondary { background: transparent; border: 1px solid ${t.border}; color: ${t.textSecondary}; }
    .ufp-btn-secondary:hover { background: ${t.bgHover}; color: ${t.textPrimary}; }
    .ufp-error { background: ${t.dangerBg}; color: ${t.danger}; padding: 14px 20px; border-radius: 14px; margin-bottom: 20px; }
    .ufp-empty { text-align: center; padding: 60px 20px; color: ${t.textMuted}; }

    /* Modal de leitura */
    .ufp-overlay { position: fixed; inset: 0; background: ${t.overlay}; backdrop-filter: blur(6px); z-index: 800; display: flex; align-items: stretch; justify-content: stretch; padding: 20px; }
    .ufp-reader { background: ${t.bgDropdown}; border: 1px solid ${t.border}; border-radius: 22px; box-shadow: ${t.shadow}; width: 100%; display: flex; flex-direction: column; overflow: hidden; position: relative; }
    .ufp-reader-header { display: flex; align-items: center; justify-content: space-between; padding: 20px 28px; border-bottom: 1px solid ${t.border}; flex-shrink: 0; }
    .ufp-reader-title { font-size: 1.15rem; font-weight: 700; color: ${t.textPrimary}; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 70%; }
    .ufp-reader-close { width: 32px; height: 32px; border-radius: 10px; border: none; background: ${t.bgHover}; color: ${t.textSecondary}; display: flex; align-items: center; justify-content: center; cursor: pointer; }
    .ufp-reader-close:hover { background: ${t.bgActive}; color: ${t.textActive}; }
    .ufp-reader-content { flex: 1; overflow-y: auto; padding: 32px 28px; position: relative; }
    .ufp-reader-content h1, .ufp-reader-content h2, .ufp-reader-content h3 { margin-top: 0; }
    .ufp-reader-content p { margin: 0.8em 0; }

    /* Container para botões flutuantes */
    .ufp-float-buttons {
      position: absolute;
      bottom: 24px;
      right: 24px;
      z-index: 10;
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .ufp-play-btn {
      width: 50px;
      height: 50px;
      border-radius: 28px;
      border: none;
      background: linear-gradient(135deg, #00aaff, #0044ee);
      color: #fff;
      box-shadow: 0 8px 24px rgba(0,100,255,0.4);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.2s;
    }
    .ufp-play-btn:hover {
      transform: scale(1.05);
    }
    .ufp-notas-btn {
      width: 50px;
      height: 50px;
      border-radius: 28px;
      border: none;
      background: linear-gradient(135deg, #00aaff, #0044ee);
      color: #fff;
      box-shadow: 0 8px 24px rgba(0,100,255,0.4);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      transition: transform 0.2s;
    }
    .ufp-notas-btn:hover {
      transform: scale(1.05);
    }
      .ufp-audio-modal {
  background: ${t.bgDropdown};
  border: 1px solid ${t.border};
  border-radius: 20px;
  box-shadow: ${t.shadow};
  width: 100%;
  max-width: 380px;
  padding: 0;
  overflow: hidden;
}
.ufp-audio-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid ${t.border};
}
.ufp-audio-header h3 { margin: 0; font-size: 1rem; color: ${t.textPrimary}; }
.ufp-audio-body { padding: 22px; display: flex; flex-direction: column; gap: 18px; }
.ufp-voice-select-full { width: 100%; max-width: none; font-size: 0.84rem; padding: 10px 12px; }
.ufp-progress-track {
  width: 100%;
  height: 8px;
  border-radius: 6px;
  background: ${t.bgHover};
  overflow: hidden;
}
.ufp-progress-fill {
  height: 100%;
  background: linear-gradient(135deg, #00aaff, #0044ee);
  transition: width 0.15s linear;
}
.ufp-audio-controls { display: flex; gap: 10px; justify-content: center; }
.ufp-audio-controls .ufp-btn:disabled { opacity: 0.5; cursor: not-allowed; }

    .ufp-voice-select {
  max-width: 160px;
  font-size: 0.72rem;
  padding: 6px 8px;
  border-radius: 10px;
  border: 1px solid ${t.border};
  background: ${t.bgCard};
  color: ${t.textPrimary};
  cursor: pointer;
  outline: none;
}

    /* Painel lateral de notas */
    .ufp-notas-panel { position: absolute; top: 0; right: 0; width: 320px; height: 100%; background: ${t.bgCard}; border-left: 1px solid ${t.border}; box-shadow: -4px 0 24px rgba(0,0,0,0.1); display: flex; flex-direction: column; transform: ${notasPanel ? 'translateX(0)' : 'translateX(100%)'}; transition: transform 0.25s ease; z-index: 15; }
    .ufp-notas-inner { display: flex; flex-direction: column; height: 100%; }
    .ufp-notas-header { padding: 20px; border-bottom: 1px solid ${t.border}; display: flex; justify-content: space-between; align-items: center; }
    .ufp-notas-header h3 { margin: 0; font-size: 0.95rem; color: ${t.textPrimary}; }
    .ufp-notas-close { background: none; border: none; color: ${t.textSecondary}; cursor: pointer; font-size: 1.2rem; }
    .ufp-notas-body { flex: 1; padding: 16px; overflow-y: auto; }
    .ufp-notas-textarea { width: 100%; height: 100%; min-height: 200px; border-radius: 12px; border: 1px solid ${t.border}; background: ${t.bgInput}; color: ${t.textPrimary}; padding: 14px; font-size: 0.86rem; resize: none; outline: none; }
    .ufp-notas-textarea:focus { border-color: #0090e7; }
    .ufp-notas-footer { padding: 16px; border-top: 1px solid ${t.border}; display: flex; gap: 10px; justify-content: flex-end; }
    .ufp-notas-save { height: 38px; padding: 0 16px; border-radius: 10px; background: linear-gradient(135deg, #00aaff, #0044ee); color: #fff; border: none; font-weight: 600; font-size: 0.82rem; cursor: pointer; display: flex; align-items: center; gap: 6px; }
    .ufp-notas-save:disabled { opacity: 0.6; }
    .ufp-feedback { font-size: 0.75rem; padding: 4px 8px; border-radius: 6px; margin-top: 6px; }
    .ufp-feedback.success { background: ${t.successBg}; color: ${t.success}; }
    .ufp-feedback.error { background: ${t.dangerBg}; color: ${t.danger}; }

    .mini-spinner { width: 14px; height: 14px; border-radius: 50%; border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff; animation: spin 0.7s linear infinite; display: inline-block; }
    @keyframes spin { to { transform: rotate(360deg); } }

    @media (max-width: 640px) {
      .ufp-notas-panel { width: 280px; }
      .ufp-reader-content { padding: 24px 16px; }
    }
  `;

  return (
    <div className="ufp-page">
      <style>{styles}</style>
      <div className="ufp-container">
        <div className="ufp-header">
          <h1 className="ufp-heading">Minhas Formações</h1>
          <p className="ufp-sub">Formações que lhe foram atribuídas</p>
        </div>

        {errorMsg && <div className="ufp-error">{errorMsg}</div>}

        <div className="ufp-search">
          <div className="ufp-search-box">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={t.textMuted} strokeWidth="2.5" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input
              placeholder="Pesquisar por título..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {loading ? (
          <div className="ufp-grid">
            {[1,2,3].map(i => (
              <div key={i} className="ufp-card" style={{ minHeight: 140, background: t.bgCard }}>
                <div style={{ height: 18, width: "60%", background: t.bgHover, borderRadius: 6 }} />
                <div style={{ height: 14, width: "80%", background: t.bgHover, borderRadius: 6, marginTop: 8 }} />
              </div>
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div className="ufp-empty">Nenhuma formação encontrada.</div>
        ) : (
          <div className="ufp-grid">
            {filtered.map((f) => {
              const plainText = f.texto?.replace(/<[^>]*>/g, "")?.substring(0, 90) || "";
              return (
                <div key={f.id} className="ufp-card">
                  <div className="ufp-card-title">{f.titulo || "Formação"}</div>
                  <div className="ufp-card-text" title={plainText}>{plainText}{plainText.length >= 90 ? "…" : ""}</div>
                  <div className="ufp-card-actions">
                    <button className="ufp-btn ufp-btn-primary" onClick={() => openView(f)}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                      Visualizar
                    </button>
                    <button className="ufp-btn ufp-btn-secondary" onClick={() => navigate(`/quiz/${code}`)}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2 3 14h7l-1 8 10-12h-7z"/></svg>
                      Fazer teste
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Leitor de formação */}
      {viewingFormacao && (
        <div className="ufp-overlay" onClick={closeView}>
          <div className="ufp-reader" onClick={(e) => e.stopPropagation()}>
            <div className="ufp-reader-header">
              <div className="ufp-reader-title">{viewingFormacao.titulo || "Formação"}</div>
              <button className="ufp-reader-close" onClick={closeView}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            <div className="ufp-reader-content">
              <div dangerouslySetInnerHTML={{ __html: viewingFormacao.texto }} />
            </div>

            {/* Botões flutuantes (PLAY + NOTAS) */}
              <div className="ufp-float-buttons">
  <button className="ufp-play-btn" onClick={handleOpenAudioModal} title="Ouvir formação">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
      <polygon points="5,3 19,12 5,21" />
    </svg>
  </button>
  <button className="ufp-notas-btn" onClick={toggleNotas} title="Notas pessoais">
    📝
  </button>
</div>

            {/* Painel lateral de notas */}
            <div className="ufp-notas-panel" style={{ transform: notasPanel ? 'translateX(0)' : 'translateX(100%)' }}>
              <div className="ufp-notas-inner">
                <div className="ufp-notas-header">
                  <h3>Notas</h3>
                  <button className="ufp-notas-close" onClick={() => setNotasPanel(false)}>✕</button>
                </div>
                <div className="ufp-notas-body">
                  {notaLoading ? (
                    <div style={{ textAlign: 'center', padding: 20 }}>A carregar...</div>
                  ) : (
                    <textarea
                      className="ufp-notas-textarea"
                      value={notaTexto}
                      onChange={(e) => setNotaTexto(e.target.value)}
                      placeholder="Escreva as suas notas sobre esta formação..."
                    />
                  )}
                  {notaFeedback && (
                    <div className={`ufp-feedback ${notaFeedback.type}`}>{notaFeedback.msg}</div>
                  )}
                </div>
                <div className="ufp-notas-footer">
                  <button
                    className="ufp-notas-save"
                    onClick={handleSaveNota}
                    disabled={notaSalvando || notaLoading}
                  >
                    {notaSalvando && <span className="mini-spinner" />}
                    Salvar
                  </button>
                </div>
              </div>
            </div>
{audioModalOpen && (
  <div className="ufp-audio-overlay" onClick={handleCloseAudioModal}>
    <div className="ufp-audio-modal" onClick={(e) => e.stopPropagation()}>
      <div className="ufp-audio-header">
        <h3>Ouvir formação</h3>
        <button className="ufp-reader-close" onClick={handleCloseAudioModal}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <div className="ufp-audio-body">
        {vozes.length > 0 && (
          <div className="ufp-select-wrap">
            <select
              className="ufp-voice-select ufp-voice-select-full"
              value={vozSelecionada?.name || ""}
              disabled={isSpeaking}
              onChange={(e) => {
                const v = vozes.find((voz) => voz.name === e.target.value);
                setVozSelecionada(v || null);
              }}
            >
              {vozes.map((v) => (
                <option key={v.name} value={v.name}>
                  {v.name} ({v.lang})
                </option>
              ))}
            </select>
            <svg className="ufp-select-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </div>
        )}

        <div className="ufp-progress-track">
          <div className="ufp-progress-fill" style={{ width: `${progress}%` }} />
        </div>

        <div className="ufp-audio-controls">
          {!isSpeaking ? (
            <button
              className="ufp-btn ufp-btn-primary"
              onClick={() => {
                const cleanText = stripHtml(viewingFormacao.texto);
                falar(cleanText);
              }}
            >
              ▶ Reproduzir
            </button>
          ) : isPaused ? (
            <button className="ufp-btn ufp-btn-primary" onClick={retomarFala}>
              ▶ Continuar
            </button>
          ) : (
            <button className="ufp-btn ufp-btn-secondary" onClick={pausarFala}>
              ⏸ Pausar
            </button>
          )}

          <button className="ufp-btn ufp-btn-secondary" onClick={pararFala} disabled={!isSpeaking}>
            ⏹ Parar
          </button>
        </div>
      </div>
    </div>
  </div>
)}


          </div>
        </div>
      )}
    </div>
  );
}